import { Controller } from '@hotwired/stimulus'
import flatpickr from '@/vendors/flatpickr'

const formatter = new Intl.DateTimeFormat()

export default class extends Controller {
  static targets = ['emptyChip', 'input', 'label', 'valueChip']

  static values = {
    emptyLabel: String
  }

  #datepicker

  connect() {
    this.#datepicker = flatpickr(this.element, {
      defaultDate: this.inputTarget.value,
      onChange: (_selectedDates, dateStr, _instance) => (this.inputTarget.value = dateStr),
      positionElement: this.element
    })

    this.#adjustDisplay()
  }

  clear(e) {
    e.preventDefault()
    e.stopPropagation()
    this.#datepicker.clear()
  }

  disconnect() {
    this.#datepicker.destroy()
  }

  open(e) {
    e.preventDefault()
    e.stopPropagation()
    this.#datepicker.open()
  }

  submit() {
    this.element.requestSubmit()
  }

  #adjustDisplay() {
    if (this.inputTarget.value) {
      this.labelTarget.innerText = formatter.format(Date.parse(this.inputTarget.value))
      this.#hide(this.emptyChipTarget)
      this.#show(this.valueChipTarget)
    } else {
      this.#show(this.emptyChipTarget)
      this.#hide(this.valueChipTarget)
    }
  }

  #hide(element) {
    element.classList.add('hidden')
  }

  #show(element) {
    element.classList.remove('hidden')
  }
}
